'use client'

import { Navigation } from '@/components/organisms/Navigation'
import { Footer } from '@/components/organisms/Footer'
import { FunnelHero } from '@/components/organisms/services/FunnelHero'
import { PhaseNav } from '@/components/organisms/services/PhaseNav'
import { PhaseBlueprint } from '@/components/organisms/services/PhaseBlueprint'
import { PhaseChoosePath } from '@/components/organisms/services/PhaseChoosePath'
import { PhaseFullStack } from '@/components/organisms/services/PhaseFullStack'
import { PhaseAdvisory } from '@/components/organisms/services/PhaseAdvisory'
import { VentureStudio } from '@/components/organisms/services/VentureStudio'
import { ServicesCTA } from '@/components/organisms/services/ServicesCTA'

export function ServicesFunnel() {
  return (
    <div className="min-h-screen bg-[#1d212a]">
      <Navigation />
      <PhaseNav />
      <FunnelHero />
      <PhaseBlueprint />
      <PhaseChoosePath />
      <PhaseFullStack />
      <PhaseAdvisory />
      <VentureStudio />
      <ServicesCTA />
      <Footer />
    </div>
  )
}
